// Static credentials for demo purposes
export const staticCredentials = {
  'admin@futureforward.edu': {
    password: 'admin123',
    user: {
      id: 1,
      email: 'admin@futureforward.edu',
      firstName: 'Sarah',
      lastName: 'Johnson',
      role: 'ADMIN',
      entityId: 1,
      isActive: true,
      createdAt: new Date().toISOString(),
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150',
      department: 'Administration',
      phone: '+1 (555) 123-4567'
    }
  },
  'educator@futureforward.edu': {
    password: 'educator123',
    user: {
      id: 2,
      email: 'educator@futureforward.edu',
      firstName: 'Michael',
      lastName: 'Chen',
      role: 'EDUCATOR',
      entityId: 1,
      isActive: true,
      createdAt: new Date().toISOString(),
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
      department: 'Mathematics',
      phone: '+1 (555) 234-5678',
      subjects: ['Mathematics', 'Physics'],
      classrooms: ['Grade 10A', 'Grade 11B']
    }
  },
  'student@futureforward.edu': {
    password: 'student123',
    user: {
      id: 3,
      email: 'student@futureforward.edu',
      firstName: 'Emma',
      lastName: 'Davis',
      role: 'STUDENT',
      entityId: 1,
      isActive: true,
      createdAt: new Date().toISOString(),
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150',
      grade: '10',
      section: 'A',
      studentId: 'STU2024001',
      parentEmail: 'parent@futureforward.edu'
    }
  },
  'family@futureforward.edu': {
    password: 'family123',
    user: {
      id: 4,
      email: 'family@futureforward.edu',
      firstName: 'Robert',
      lastName: 'Davis',
      role: 'FAMILY',
      entityId: 1,
      isActive: true,
      createdAt: new Date().toISOString(),
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150',
      relationship: 'Father',
      phone: '+1 (555) 345-6789',
      children: [
        {
          id: 3,
          name: 'Emma Davis',
          grade: '10',
          section: 'A',
          studentId: 'STU2024001'
        }
      ]
    }
  }
}

export const fallback = {
  demoUser: staticCredentials['admin@futureforward.edu'].user,

  users: Object.values(staticCredentials).map(cred => cred.user),

  applications: [
    { id: 101, name: 'Math Master', description: 'Learn math with fun exercises', url: 'https://example.com/math', category: 'Math', entityId: 1, status: 'ACTIVE', createdById: 1 },
    { id: 102, name: 'Science Quest', description: 'Explore science topics', url: 'https://example.com/science', category: 'Science', entityId: 1, status: 'ACTIVE', createdById: 2 },
    { id: 103, name: 'History Hub', description: 'Interactive history lessons', url: 'https://example.com/history', category: 'History', entityId: null, status: 'ACTIVE', createdById: 1 }
  ],

  userApplications: [
    { id: 1001, userId: 3, applicationId: 101, isActive: true },
    { id: 1002, userId: 3, applicationId: 102, isActive: true },
    { id: 1003, userId: 1, applicationId: 103, isActive: true }
  ],

  progress: [
    { id: 2001, userId: 3, applicationId: 101, status: 'IN_PROGRESS', timeSpent: 120, completionRate: 0.6, data: {}, lastAccessed: new Date().toISOString(), updatedAt: new Date().toISOString() },
    { id: 2002, userId: 3, applicationId: 102, status: 'COMPLETED', timeSpent: 90, completionRate: 1.0, data: {}, lastAccessed: new Date().toISOString(), updatedAt: new Date().toISOString() }
  ]
}

export function paginate(array, page = 1, limit = 10) {
  const start = (Number(page) - 1) * Number(limit)
  const end = start + Number(limit)
  const items = array?.applications.slice(start, end)
  return {
    items,
    pagination: {
      page: Number(page),
      limit: Number(limit),
      total: array?.applications?.length,
      pages: array?.pagination?.pages
    }
  }
}

export function getUserApplications(userId) {
  const assigned = fallback.userApplications.filter(ua => ua.userId === Number(userId) && ua.isActive)
  return assigned.map(ua => ({
    ...ua,
    ...fallback.applications.find(a => a.id === ua.applicationId)
  }))
}

export function getProgressByUser(userId) {
  return fallback.progress
    .filter(p => p.userId === Number(userId))
    .map(p => ({
      ...p,
      applicationName: fallback.applications.find(a => a.id === p.applicationId)?.name,
      applicationCategory: fallback.applications.find(a => a.id === p.applicationId)?.category
    }))
}

export function getProgressStats(userId) {
  const data = fallback.progress.filter(p => p.userId === Number(userId))
  const statusBreakdown = ['NOT_STARTED','IN_PROGRESS','COMPLETED'].map(s => ({
    status: s,
    count: data.filter(p => p.status === s).length
  }))
  const totalTimeSpent = data.reduce((acc, p) => acc + (p.timeSpent || 0), 0)
  const averageCompletionRate = data.length ? (data.reduce((acc, p) => acc + (p.completionRate || 0), 0) / data.length) : 0
  const recentActivity = [...data].sort((a,b) => new Date(b.lastAccessed) - new Date(a.lastAccessed)).slice(0,5)
  return { statusBreakdown, totalTimeSpent, averageCompletionRate, recentActivity }
} 